/**
 * 숫자 전용 입력 필드 props 생성기.
 * type="text" inputMode="numeric|decimal" 방식으로 동작하므로
 * onChange가 모든 입력에서 확실하게 발생하고 raw 값을 검증할 수 있습니다.
 *
 * @param {string}   value       - 현재 값 (controlled)
 * @param {function} setter      - 값 업데이트 함수 (val: string) => void
 * @param {function} showToast   - toast 표시 함수
 * @param {object}   [opts]
 * @param {boolean}  [opts.allowDecimal=false]  - 소수점 허용
 */
export function numericProps(value, setter, showToast, { allowDecimal = false } = {}) {
    const pattern = allowDecimal ? /^\d*\.?\d*$/ : /^\d*$/;

    return {
        type: 'text',
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        value,
        onChange: (e) => {
            const raw = e.target.value;
            if (raw === '' || pattern.test(raw)) {
                setter(raw);
            } else {
                showToast('숫자만 입력 가능해요');
                // 커서가 있는 위치에서 invalid 문자만 걸러낸 값으로 복원
                const cleaned = raw.replace(allowDecimal ? /[^\d.]/g : /[^\d]/g, '');
                setter(cleaned);
            }
        },
    };
}
